import { render, staticRenderFns } from "./multiVesselOffer.vue?vue&type=template&id=5e689a88&"
import script from "./multiVesselOffer.vue?vue&type=script&lang=js&"
export * from "./multiVesselOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports